import { Link } from "react-router-dom";

export const LogoMark = ({ variant = "classic", className = "h-8" }) => (
  <img src={`/dt-logo-${variant}.png`} alt="Dream Teams" className={`${className} w-auto select-none`} draggable="false" />
);

export const Logo = ({ to = "/", variant = "classic", className = "h-8 sm:h-9" }) => (
  <Link to={to} data-testid="brand-logo" className="flex items-center shrink-0">
    <LogoMark variant={variant} className={className} />
  </Link>
);
